module.exports = __webpack_public_path__ + "static/media/01_Referenz_5w-50-min.f99af352.webp";